<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

    <el-col :xs="8" :sm="8" :lg="8">
      <el-button type="normal" @click.prevent="goBack" class="ml-20" circle>
        <i class="el-icon-d-arrow-left"></i>
      </el-button>
    </el-col>
    <el-col :xs="16" :sm="16" :lg="16" style="text-align: right">
      <el-button v-if="job.jobInfo.alreadySigned === 'no'" type="primary" @click.prevent="handleSign" class="mr-20">簽核 <i
          class="el-icon-s-claim"></i></el-button>
      <el-tag v-if="job.jobInfo.alreadySigned === 'yes'" type="warning" class="mr-20">已簽核</el-tag>
    </el-col>


   

    <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>基本資料</span>
          </div>
          <div>
            <el-form class="myform">

              <el-row>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="人員：">
                    {{job.todoInfo.userObj.username}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="標題：">
                    {{job.todoInfo.title}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="報表日期：">
                    {{job.todoInfo.startDate | fmtDate}}
                  </el-form-item>
                </el-col>
              </el-row>
              
            </el-form>

          </div>
        </el-card>
      </el-main>
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="taskMain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>工作項目</span>
            
          </div>
          <div>
            <el-table :data="job.paintingHistory" empty-text="無資料" stripe :default-expand-all="true">
              <el-table-column label="項次" width="50">
                <template slot-scope="scope">{{scope.$index+1}}</template>
              </el-table-column>
              <el-table-column label="產品" prop="product">
              </el-table-column>
              <el-table-column label="" type="expand" >
                <template slot-scope="scope">
                  <p class="mt-10 ml-10">效果: {{scope.row.result}}</p>
                  <p class="mt-10 ml-10">{{scope.row.resultNotes}}</p>
                  <p class="mt-10 ml-10">{{scope.row.deliveryAddress}}</p>
                  <p class="mt-10 ml-10">數量: {{scope.row.qty}}</p>
                  <p class="mt-10 ml-10">進度: {{scope.row.progress}}</p>
                  <p class="mt-10 ml-10">花費時長:  {{scope.row.timeHour}} 時 {{scope.row.timeMinute}}分鐘</p>


                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>

                    

                  </li>
                </ol>
                </template>
              </el-table-column>

              


            </el-table>


          </div>
        </el-card>
      </el-main>
    </el-col>




    <el-col :xs="24" :sm="24" :lg="24" v-if="job.jobInfo.status !== 'draft'" class="mt-20">
      <el-main class="taskMain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>簽核紀錄</span>
          </div>
          <div>

            <el-table :data="job.signoffHistory" empty-text="無資料" stripe :default-expand-all="true">
              <el-table-column label="時間" prop="updatedAt" width="170">
                <template slot-scope="scope">
                  <p>簽核時間 :</p>
                  <p>{{ scope.row.updatedAt | fmtDateTime }}</p>
                  <p class="mt-10">{{ scope.row.signerObj.username }}</p>
                </template>
              </el-table-column>
              <el-table-column label="結果" prop="signResult">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.signResult === 'N'" type="danger">{{ scope.row.signResult | signResult }}</el-tag>
                  <el-tag v-else>{{ scope.row.signResult | signResult }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="" type="expand" width="30">
                  <template slot-scope="scope">
                    <p class="mt-10 ml-10">簽核備註 : {{ scope.row.notes }}</p>
                  </template>
                </el-table-column>

                <el-table-column>
                </el-table-column>
            </el-table>

          </div>
        </el-card>
      </el-main>
    </el-col>

    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    
    <el-dialog title="簽核資訊"
               :visible.sync="signoff.dialog"
               :width="dw">

      <el-form :model="job.jobInfo" ref="signForm" :rules="signFormRules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="簽核選擇" prop="signResult">
              <el-radio v-model="job.jobInfo.signResult" label="Y">同意</el-radio>
              <el-radio v-model="job.jobInfo.signResult" label="N">退回</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="備註" prop="notes">
              <el-input rows="5" type="textarea" v-model="job.jobInfo.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="signoff.dialog = false">取 消</el-button>
        <el-button type="primary" @click="sendSignoff('signForm')">確 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="附件圖"
           :visible.sync="img.dialog"
           :width="dw">
    <div class="demo-image">
      <el-image
        style="width: 100%; max-width: 100%; height: 100%;"
        :src="img.url"
        fit="cover" lazy>
          <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i> 開啟中...
            </div>
        </el-image>
    </div>
 </el-dialog>



  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'

export default {
  name: "TodoDetailEmpMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
       if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    let checkRadio = (rule, value, callback) => {
      console.log("checkRadio:", rule, value)
       if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請選擇同意或退回'))
      } else {
        callback()
      }
    }

    return {
      img:{
        dialog: false,
        url:''
      },

      dw: '50%',
      alreadySigned: '',
      tableData: [],
      options: [],
      logTypeOptions: [{
        value: '補漆',
        label: '補漆'
      }, {
        value: '補缺',
        label: '補缺'
      }],
      basicForm: {
        id: '',
        title: '',
        startDate: '',
        endDate: '',
        status: '',
        userObj:{}
      },

      signoff:{
        dialog: false,
        notes: '',
        rules: {
          signResult: [{required: true, validator: checkRadio, trigger: 'change'}]
          // notes: [{required: true, validator: checkName, trigger: 'change'}]
        }
      },

      job:{
        id:'',
        jobInfo:{
          id:'',
          alreadySigned:'no'
        },
        todoInfo:{
          userObj:{}
        },
        divMgrHistory:[],
        customerHistory:[],
        signoffHistory:[],
        paintingHistory:[]
      },

      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      btnCount: 0,
      form: {
        id: '',
        todoId: '',
        signResult: '',
        notes: '',
        relatedUser: '',
        flowStep:''
      },
      signFormRules: {
        signResult: [{required: true, validator: checkRadio, trigger: 'change'}]
      }
    }
  },
  computed: {
    ...mapState('login', ['userInfo'])
  },
  methods: {
    showImage(uuid) {
      this.img.dialog = true
      this.img.url = this.displayAvatar(uuid)
    },
    goBack() {
      this.$router.push('/message/my-signoff')
    },
    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    save(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('valid:', valid)
        if (valid) {
            this.request.post("/todo/emp/history", this.form).then(res => {
              if (res.code === '200') {
                this.dialogFormVisible = false
                this.loadHistoryData()
                this.showResult('success', '新增成功')
              } else {
                this.showResult('error', res.message)
              }
            })
        }
      });

      
    },
    closeDialog() {
      this.$refs['dailyJobRuleForm'].resetFields()
      this.loadHistoryData()
    },

    formDefault() {
      this.request.get("/todo/" + this.form.todoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data
        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      // this.form.todoType = this.getTodoType()
    },

    loadHistoryData() {

      //先撈job
      this.request.get("/job/" + this.form.id).then(res => {
        if (res.code === '200') {
          this.form.todoId = res.data.todoId
          this.form.relatedUser = res.data.relatedUser
          this.form.flowStep = res.data.flowStep
          this.alreadySigned = res.data.alreadySigned
          
          this.formDefault()
          
          this.request.get("/todo/emp/history/" + this.form.todoId).then(res => {
            if (res.code === '200') {
              this.tableData = res.data
            } else {
              this.showResult('error', '工作紀錄撈取失敗')
            }
          })

        } else {
          this.showResult('error', '工作訪紀錄撈取失敗')
        }
      })
      
    },

    findJobContent() {
      this.request.get("/job/detail/" + this.job.id).then(res => {
        if (res.code === '200') {
          this.job = res.data
        }
      })
    },
    
    handleSign() {
      this.signoff.dialog = true
      this.signoff.notes = ''
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%";
      }
    },
    handleDelete(id) {
      this.request.delete("/todo/emp/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    sendSignoff(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.request.post("/job", this.job.jobInfo).then(res => {
            if (res.code === '200') {
              this.showResult('success', '完成簽核')
              this.signoff.dialog = false
              this.$router.push('/message/my-signoff')
            } else {
              this.showResult('error', '簽核結果儲存失敗')
            }
          })
        }
      })
    }
  },
  mounted() {

    //this.form.id = this.$route.params.jobId
    this.job.id = this.$route.params.jobId

    // this.loadHistoryData()


    this.findJobContent()

    this.setDialogWidth()

    
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}


.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0 4px;
}
.el-table {
  padding: 0;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-autocomplete {
  width: 100%;
}
.el-card__body {
  padding: 20px 0 !important;
}

.myform >>> .el-form-item__label {
  padding: 0;
}
</style>
